class SettlementConfigurationModelConsts {
  public static readonly NameMaxLength: number = 100;

  public static readonly DescriptionMaxLength: number = 255;

  public static readonly CurrencyLength: number = 3;
}

export default SettlementConfigurationModelConsts;
